// import DatePicker from "react-datepicker";
import React, { useState, useEffect, forwardRef } from "react";
import PropTypes from "prop-types";
import "react-datepicker/dist/react-datepicker.css";
import { DatePicker } from "rsuite";
import { useTranslation } from "react-i18next";
import Calender from "../assets/images/svgs/calendar.svg";
import "rsuite/dist/rsuite.min.css";

// Custom Input (allows icon click and input typing)
const CustomInput = forwardRef(
  ({ value, placeholder, onClick, onChange }, ref) => (
    <div className="date-picker-wrapper d-flex" ref={ref}>
      <input
        type="text"
        value={value}
        onChange={onChange}
        onClick={onClick}
        className="date-input form-control form-control-solid"
        placeholder={placeholder}
      />
      <img
        src={Calender}
        alt=""
        className="svg-icon"
        style={{ marginLeft: "-40px", cursor: "pointer" }}
        onClick={onClick}
        loading="lazy"
      />
    </div>
  )
);

const DateInput = ({
  name,
  value,
  title,
  handleChange,
  error,
  disabled,
  page,
  style,
  smallInput,
  placeholder,
  border,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (value) {
      setSelectedDate(value);
    }
  }, [value]);

  useEffect(() => {
    if (selectedDate) {
      handleChange({ name, value: selectedDate });
    }
  }, [selectedDate]);

  const handleRawChange = (e) => {
    setSelectedDate(e);
  };

  return (
    <div className={`   text-start`}>
      {title && (
        <label className="d-flex align-items-center fs-12 mb-1 form-label">
          <span className="required">{title}</span>
        </label>
      )}

      <DatePicker
        value={selectedDate}
        onChange={handleRawChange}
        className={`custom-small-datepicker ${border ? "cus" : "  "} ${
          smallInput ? "small no-border-datepicker" : ""
        } 
    `}
        style={{
          color: "#ccd6f6",
          width: smallInput ? "150px" : "100%",
          border: "1px solid #3a3f5c !important",
        }}
        placeholder={placeholder}
      />

      <div style={page ? { height: "20px" } : {}} className="mb-2">
        <span className="fs-10 text-danger">{error}</span>
      </div>
    </div>
  );
};

DateInput.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  page: PropTypes.string,
  style: PropTypes.any,
  smallInput: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default DateInput;
